/**
 * @generated SignedSource<<20be0d6fb2bc7a010a7690cf1dc8aee5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WSTodoSummaryQuery$variables = {
  id: string;
};
export type WSTodoSummaryQuery$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetOverviewSettings_Store">;
  };
  readonly widgetTodoSummary: {
    readonly assignedTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly category: {
      readonly id: string;
    } | null;
    readonly id: string;
  } | null;
};
export type WSTodoSummaryQuery = {
  response: WSTodoSummaryQuery$data;
  variables: WSTodoSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "WidgetTodoSummary",
  "kind": "LinkedField",
  "name": "widgetTodoSummary",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "assignedTeams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTodoSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetOverviewSettings_Store"
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSTodoSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "93e3a58161de78ab412766d049f9741c",
    "id": null,
    "metadata": {},
    "name": "WSTodoSummaryQuery",
    "operationKind": "query",
    "text": "query WSTodoSummaryQuery(\n  $id: ID!\n) {\n  store {\n    ...WidgetOverviewSettings_Store\n    id\n  }\n  widgetTodoSummary(id: $id) {\n    id\n    category {\n      id\n    }\n    assignedTeams {\n      id\n    }\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment WidgetOverviewSettings_Store on Store {\n  publicTeams {\n    id\n    ...TeamSelectList_Team\n  }\n}\n"
  }
};
})();

(node as any).hash = "4931b0388c6b171d1b7645fd8d79457b";

export default node;
